// Will probably be removed in the future, after Waitlists are migrated to X2.
export enum ExperienceItemStatus {
    // "Reserved" statuses.
    REQUESTED = 100,
    PENDING_MINIMUM = 101,
    PENDING_MINIMUM_PROCESSING = 102,
    HOLD = 103,
    ACCEPTED = 200,
    DEPOSIT_PAID = 201,
    ACCEPTED_NOT_CHARGED = 202,
    ACCEPTED_PAY_LATER = 203,
    RESERVED = 299, // This is a pseudo-status. All statuses less than this are considered "reserved".

    // "Non-reserved" statuses.
    DECLINED = 300,
    PAYMENT_FAILED = 500,
    NO_SHOW = 501,
    WAITLIST_CREATED = "waitlist_created",
    WAITLIST_CONFIRMED = "waitlist_confirmed",
    WAITLIST_REMOVED = "waitlist_removed",
    OFFERED = 600,
    CANCELED = 700,
}
